<template>
  <div>
    <load v-if="loading" mode="table" message="Atualizando informações" />
    <form v-show="!loading" @submit.prevent="submit">
      <div class="row">
        <form-input
          inputGroup="true"
          btnText="R$"
          type="money"
          label="Pobreza"
          grid="4"
          v-model="extrema_pobreza"
          :required="true"
        />

        <form-input
          inputGroup="true"
          btnText="R$"
          type="money"
          label="Situação Pobreza"
          grid="4"
          v-model="pobreza"
          :required="true"
        />
        <form-input
          inputGroup="true"
          btnText="R$"
          type="money"
          label="Perfil Cadunico"
          grid="4"
          v-model="perfil_cadunico"
          :required="true"
        />
      </div>
      <div class="row px-0 d-flex justify-content-end">
        <div class="col-auto px-2 text-right">
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        extrema_pobreza: 0,
        pobreza: 0,
        perfil_cadunico: 0,
        loading: false,
      };
    },
    mounted() {
      if (this.$store.state.settings.familia_extrema_pobreza) {
        this.extrema_pobreza = this.$store.state.settings.familia_extrema_pobreza;
        this.pobreza = this.$store.state.settings.familia_pobreza;
        this.perfil_cadunico = this.$store.state.settings.familia_perfil_cadunico;
      }
    },
    methods: {
      submit() {
        this.loading = true;
        let dados = [
          {
            key: "familia_extrema_pobreza",
            value: this.extrema_pobreza,
          },
          { key: "familia_pobreza", value: this.pobreza },
          {
            key: "familia_perfil_cadunico",
            value: this.perfil_cadunico,
          },
        ];
        // Update image
        axios
          .post("api/dashboard/admin/familia/settings", dados)
          .then((response) => {
            this.loading = false;
          });
      },
    },
  };
</script>
